// YourPlants theme — base interactivity

document.addEventListener('DOMContentLoaded', function () {
  initProductGallery();
  initProductAccordion();
  initOptionSliders();
  initGiftForm();
  initColdNotice();
  initFacetsDrawer();
  initLocaleSwitcher();
  initNavDropdowns();
  initUspSlider();
  initHeroQuickOrder();
  initScrollFade();
});

// Below lg, the header's USP row can't fit on one line, so it cross-fades
// between the phrases one at a time instead of wrapping.
function initUspSlider() {
  const slider = document.querySelector('[data-usp-slider]');
  if (!slider) return;
  const slides = slider.querySelectorAll('[data-usp-slide]');
  if (slides.length < 2) return;

  let index = 0;
  setInterval(function () {
    slides[index].classList.remove('opacity-100');
    slides[index].classList.add('opacity-0');
    index = (index + 1) % slides.length;
    slides[index].classList.remove('opacity-0');
    slides[index].classList.add('opacity-100');
  }, 3000);
}

// Opens/closes each header nav item's submenu on click — same interaction as
// the language switcher, at every breakpoint (no hover: we're mobile first,
// and hover doesn't exist on touch anyway).
function initNavDropdowns() {
  const items = document.querySelectorAll('[data-nav-item]');
  if (!items.length) return;

  function closeAll(except) {
    items.forEach(function (item) {
      if (item === except) return;
      const toggle = item.querySelector('[data-nav-toggle]');
      const panel = item.querySelector('[data-nav-panel]');
      if (panel) { panel.classList.add('hidden'); panel.classList.remove('flex'); }
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  items.forEach(function (item) {
    const toggle = item.querySelector('[data-nav-toggle]');
    const panel = item.querySelector('[data-nav-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      const isOpen = !panel.classList.contains('hidden');
      closeAll(item);
      panel.classList.toggle('hidden', isOpen);
      panel.classList.toggle('flex', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', function (event) {
    const withinAnyItem = Array.from(items).some(function (item) { return item.contains(event.target); });
    if (!withinAnyItem) closeAll();
  });
}

// Toggles the header's language dropdown (only present once a second locale exists).
function initLocaleSwitcher() {
  const toggle = document.querySelector('[data-locale-toggle]');
  const panel = document.querySelector('[data-locale-panel]');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    const isOpen = !panel.classList.contains('hidden');
    panel.classList.toggle('hidden');
    panel.classList.toggle('flex');
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('click', function (event) {
    if (!toggle.contains(event.target) && !panel.contains(event.target)) {
      panel.classList.add('hidden');
      panel.classList.remove('flex');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
}

// Opens/closes the "Filter en sorteer" drawer on collection pages.
function initFacetsDrawer() {
  // The sort dropdown submits its form on change (was an inline onchange attribute).
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });

  const drawer = document.querySelector('[data-facets-drawer]');
  const openButton = document.querySelector('[data-facets-open]');
  if (!drawer || !openButton) return;

  function open() {
    drawer.classList.remove('hidden');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  function close() {
    drawer.classList.add('hidden');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  openButton.addEventListener('click', open);
  drawer.querySelectorAll('[data-facets-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
}

function initProductGallery() {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const tiles = Array.from(gallery.querySelectorAll('[data-gallery-open]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const dialogImg = gallery.querySelector('[data-gallery-dialog-img]');
    let current = 0;

    // Phones: the dots follow the swipe
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        const first = tiles[0];
        if (!first) return;
        const step = first.offsetWidth + 12;
        const index = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / step)));
        dots.forEach(function (dot, i) {
          dot.classList.toggle('bg-primary', i === index);
          dot.classList.toggle('bg-black/20', i !== index);
        });
      }, { passive: true });
    }

    if (!dialog || !dialogImg) return;

    function show(index) {
      current = (index + tiles.length) % tiles.length;
      dialogImg.src = tiles[current].getAttribute('data-full-src');
      dialogImg.alt = tiles[current].getAttribute('data-alt') || '';
    }

    tiles.forEach(function (tile, index) {
      tile.addEventListener('click', function () {
        show(index);
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const close = gallery.querySelector('[data-gallery-close]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (close) close.addEventListener('click', function () { dialog.close(); });
    // a click on the dark backdrop closes it too
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
  });
}

// The product-info accordion (Beschrijving / Specificaties / Versgarantie /
// Verzorging) opens one item at a time and flips its chevron.
function initProductAccordion() {
  document.querySelectorAll('[data-product-accordion]').forEach(function (accordion) {
    const items = accordion.querySelectorAll('[data-accordion-item]');
    items.forEach(function (item) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const panel = item.querySelector('[data-accordion-panel]');
      const chevron = trigger.querySelector('svg');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', function () {
        const isOpen = !panel.classList.contains('hidden');
        items.forEach(function (other) {
          other.querySelector('[data-accordion-panel]').classList.add('hidden');
          const otherChevron = other.querySelector('[data-accordion-trigger] svg');
          if (otherChevron) otherChevron.classList.remove('rotate-180');
        });
        if (!isOpen) {
          panel.classList.remove('hidden');
          if (chevron) chevron.classList.add('rotate-180');
        }
      });
    });
  });
}

// Pot / extras sliders: arrow buttons appear only when there is more to scroll.
function initOptionSliders() {
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track || !prev || !next) return;
    function update() {
      const max = track.scrollWidth - track.clientWidth;
      prev.classList.toggle('hidden', track.scrollLeft <= 2);
      prev.classList.toggle('flex', track.scrollLeft > 2);
      const more = max > 2 && track.scrollLeft < max - 2;
      next.classList.toggle('hidden', !more);
      next.classList.toggle('flex', more);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

// The steps of a plant (pot, card, extras):
// - with two or more, only the first is shown; the next one appears once a
//   choice has been made in the open step. Steps stay open once shown.
// - "In plantenmand" looks disabled until every step has an answer (a choice,
//   or an explicit "none"). Clicking it early scrolls to the open step and
//   flashes it.
function initStepFlow(form) {
  const steps = Array.from(form.querySelectorAll('[data-step]'));
  const button = document.getElementById('AddToCartButton');
  if (!steps.length || !button || button.disabled) return;
  const progressive = steps.length >= 2;
  let shown = progressive ? 1 : steps.length;

  // Funnel measurement: where do visitors stop in the steps? Each event is sent
  // once per page view through Shopify's customer events; the custom pixel
  // "YourPlants stappen" forwards them to Meta and GA4.
  const sent = {};
  function stepName(step) {
    if (step.querySelector('input[name="sierpot"]')) return 'pot';
    if (step.querySelector('input[name="kaart"]')) return 'kaart';
    if (step.querySelector('[data-addon-none]')) return 'extras';
    return '';
  }
  function choiceOf(step) {
    const name = stepName(step);
    if (name === 'pot') {
      const pot = step.querySelector('input[name="sierpot"]:checked');
      return pot && pot.value ? 'gekozen' : 'geen';
    }
    if (name === 'kaart') {
      const card = step.querySelector('input[name="kaart"]:checked');
      return card && card.value === 'card' ? 'met' : 'zonder';
    }
    const none = step.querySelector('[data-addon-none]:checked');
    return none ? 'geen' : 'gekozen';
  }
  function track(event, step, extra) {
    const name = step ? stepName(step) : '';
    if (step && !name) return;
    const key = event + ':' + name;
    if (sent[key]) return;
    sent[key] = true;
    try {
      if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return;
      const handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
      window.Shopify.analytics.publish(event, Object.assign({
        product_handle: handle,
        step: name,
        step_number: step ? steps.indexOf(step) + 1 : 0,
        steps_total: steps.length
      }, extra || {}));
    } catch (e) { /* measuring must never break the page */ }
  }

  function decided(step) {
    // A step without choices of ours (e.g. only Everspring's own field) never blocks.
    if (!step.querySelector('input[name="sierpot"], input[name="kaart"], [data-addon-none]')) return true;
    return !!step.querySelector('input[name="sierpot"]:checked, input[name="kaart"]:checked, [data-addon-none]:checked, input[data-addon-variant-id]:not([data-card-toggle]):checked');
  }

  function render(reveal) {
    if (progressive) {
      let next = shown;
      while (next < steps.length && decided(steps[next - 1])) next += 1;
      const opened = next > shown;
      shown = next;
      steps.forEach(function (step, i) { step.classList.toggle('hidden', i >= shown); });
      if (opened && reveal) steps[shown - 1].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    steps.forEach(function (step, i) {
      if (i < shown) track('yp_step_shown', step);
      if (reveal && decided(step)) track('yp_step_done', step, { choice: choiceOf(step) });
    });
    if (steps.every(decided)) {
      button.removeAttribute('aria-disabled');
      if (reveal) track('yp_steps_complete');
    } else button.setAttribute('aria-disabled', 'true');
  }

  button.addEventListener('click', function (event) {
    if (button.getAttribute('aria-disabled') !== 'true') return;
    event.preventDefault();
    const target = steps.find(function (step, i) { return i < shown && !decided(step); });
    if (!target) return;
    track('yp_cart_blocked', target);
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.remove('step-attention');
    void target.offsetWidth; // restart the animation
    target.classList.add('step-attention');
    window.setTimeout(function () { target.classList.remove('step-attention'); }, 1500);
  });

  form.addEventListener('change', function () { render(true); });
  form.addEventListener('steps:reveal-all', function () { shown = steps.length; render(false); });
  render(false);
}

// Cold notice: "Heatpack toevoegen" reveals all steps, ticks the heatpack and scrolls to it.
function initColdNotice() {
  const button = document.querySelector('[data-add-heatpack]');
  const form = document.getElementById('ProductForm');
  if (!button || !form) return;
  button.addEventListener('click', function () {
    const input = form.querySelector('input[data-addon-variant-id="' + button.getAttribute('data-add-heatpack') + '"]');
    if (!input) return;
    form.dispatchEvent(new CustomEvent('steps:reveal-all'));
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const step = input.closest('[data-step]') || input;
    step.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const added = button.getAttribute('data-added-label');
    if (added) button.textContent = added;
    button.disabled = true;
  });
}

// On submit, bundle the chosen sierpot (if any) and checked gift add-ons —
// each a separate product from the same Everspring supplier — together with
// the plant (plus whatever line-item properties an app block, e.g.
// Everspring's card step, added to this same form) into one /cart/add.js
// call, then go to the cart.
function initGiftForm() {
  const form = document.getElementById('ProductForm');
  if (!form) return;

  // Paid card: our checkbox opens Everspring's own message field. The card is
  // Everspring's Greeting Card product, added as a nested line under the plant.
  const cardToggle = form.querySelector('[data-card-toggle]');
  const cardError = form.querySelector('[data-card-error]');
  function cardMessageField() { return document.getElementById('everspring_greetingcard-textarea'); }
  const cardField = cardMessageField();
  if (cardToggle && cardField) cardField.placeholder = 'Schrijf hier je tekst voor het kaartje. Emoji\'s zijn helaas niet mogelijk.';
  if (cardToggle) {
    // Two radios (no card / with card): keep Everspring's own checkbox in step
    // with "with card". Radios only fire change on the one that gets selected.
    form.querySelectorAll('input[name="kaart"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        const theirs = document.getElementById('everspring_greetingcard-toggle');
        if (theirs && theirs.checked !== cardToggle.checked) theirs.click();
        if (cardError) cardError.classList.add('hidden');
      });
    });
  }

  // Option tiles: the "none" tile only lights up once the visitor has touched
  // its group, and the extras group behaves like a checklist with a "none" tile.
  form.querySelectorAll('[data-option-group]').forEach(function (group) {
    const none = group.querySelector('[data-addon-none]');
    const extras = Array.from(group.querySelectorAll('[data-addon-variant-id]'));
    group.addEventListener('change', function (event) {
      group.setAttribute('data-touched', '');
      if (!none) return;
      if (event.target === none) {
        extras.forEach(function (input) { input.checked = false; });
        none.checked = true;
      } else {
        none.checked = !extras.some(function (input) { return input.checked; });
      }
      updateTotal();
    });
  });

  // Live total next to the button: plant + chosen pot + card + extras.
  const totalEl = form.querySelector('[data-total-price]');
  function updateTotal() {
    if (!totalEl) return;
    let cents = parseInt(totalEl.getAttribute('data-base-price'), 10) || 0;
    form.querySelectorAll('input[data-price]:checked').forEach(function (input) {
      cents += parseInt(input.getAttribute('data-price'), 10) || 0;
    });
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    totalEl.textContent = totalEl.textContent.replace(/[\d.,]+/, amount);
  }
  form.addEventListener('change', updateTotal);
  initStepFlow(form);

  form.addEventListener('submit', function (event) {
    const button = document.getElementById('AddToCartButton');
    if (button && (button.disabled || button.getAttribute('aria-disabled') === 'true')) {
      event.preventDefault();
      return;
    }

    if (cardToggle && cardToggle.checked) {
      const field = cardMessageField();
      if (field && field.value.trim() === '') {
        event.preventDefault();
        if (cardError) cardError.classList.remove('hidden');
        field.focus();
        return;
      }
    }

    const addonInputs = form.querySelectorAll('[data-addon-variant-id]');
    const potInput = form.querySelector('input[name="sierpot"]:checked');
    const hasPot = potInput && potInput.value;
    event.preventDefault();
    if (button) button.disabled = true;

    const formData = new FormData(form);
    const properties = {};
    formData.forEach(function (value, key) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') properties[match[1]] = value;
    });

    // One hidden code per added plant: its pot, card and extras carry it as
    // _voor, the plant itself as _bundel. Every plant is therefore its own cart
    // line (quantity 1) and two identical plants never share each other's add-ons.
    const bundle = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    properties._bundel = bundle;

    const items = [
      {
        id: formData.get('id'),
        quantity: 1,
        properties: Object.keys(properties).length ? properties : undefined
      }
    ];

    // Pot and extras carry a hidden pointer to their plant, so the cart can keep
    // them together and drop them when the plant is removed.
    const owner = { _voor: bundle };
    if (hasPot) {
      items.push({ id: potInput.value, quantity: 1, properties: owner });
    }

    addonInputs.forEach(function (input) {
      if (input.checked) {
        const item = { id: input.getAttribute('data-addon-variant-id'), quantity: 1 };
        if (input.hasAttribute('data-card-toggle')) {
          const field = cardMessageField();
          const message = field ? field.value.trim() : '';
          if (input.hasAttribute('data-card-nested')) {
            // Everspring's own card product: a nested line under this plant.
            // Everspring prints the text from "Greeting card message" on this line;
            // Shopify removes the card together with its plant.
            item.parent_id = String(formData.get('id'));
            item.properties = { _voor: bundle };
            if (message !== '') item.properties['Greeting card message'] = message;
          } else if (message !== '') {
            item.properties = { Bericht: message, _voor: bundle };
          }
        } else {
          item.properties = owner;
        }
        items.push(item);
      }
    });

    // The cart lists the newest line first, so add the plant last: it then
    // shows on top with its pot, card and add-ons underneath.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.slice().reverse() })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        window.location.href = window.location.origin + '/cart';
      })
      .catch(function () {
        if (button) button.disabled = false;
        form.submit();
      });
  });
}

// Homepage hero: pick a moment (+ optional budget) and jump to the matching
// collection with the price filter applied. The "reason" line and the selected
// moment chip rotate together until the visitor touches the card.
function initHeroQuickOrder() {
  const root = document.querySelector('[data-hero-quick]');
  if (!root) return;

  const moments = Array.from(root.querySelectorAll('[data-moment]'));
  const budgets = Array.from(root.querySelectorAll('[data-budget]'));
  const reasonEl = root.querySelector('[data-hero-reason]');
  const cta = root.querySelector('[data-hero-cta]');
  const momentRow = root.querySelector('[data-moment-row]');
  const budgetToggle = root.querySelector('[data-budget-toggle]');
  const budgetRow = root.querySelector('[data-budget-row]');
  const budgetLabel = root.querySelector('[data-budget-label]');
  let index = 0;
  let timer = null;

  function updateCta() {
    const moment = moments.find(function (m) { return m.getAttribute('aria-pressed') === 'true'; });
    const budget = budgets.find(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    if (!moment || !cta) return;
    const params = [];
    let path = moment.dataset.url;
    if (budget) {
      // "Voor wie" choice: filter the moment collection on its tag (e.g. /collections/verjaardag/voor-haar)
      if (budget.dataset.tag) path += '/' + budget.dataset.tag;
      if (budget.dataset.min) params.push('filter.v.price.gte=' + budget.dataset.min);
      if (budget.dataset.max) params.push('filter.v.price.lte=' + budget.dataset.max);
    }
    cta.href = path + (params.length ? '?' + params.join('&') : '');
  }

  function selectMoment(i, options) {
    index = i;
    moments.forEach(function (m, n) { m.setAttribute('aria-pressed', String(n === i)); });
    if (reasonEl) {
      if (options && options.fade) {
        reasonEl.classList.add('opacity-0');
        setTimeout(function () {
          reasonEl.textContent = moments[i].dataset.reason;
          reasonEl.classList.remove('opacity-0');
        }, 300);
      } else {
        reasonEl.textContent = moments[i].dataset.reason;
      }
    }
    if (options && options.scroll && momentRow) {
      momentRow.scrollTo({ left: Math.max(0, moments[i].offsetLeft - 16), behavior: 'smooth' });
    }
    updateCta();
  }

  function stopRotation() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  moments.forEach(function (chip, i) {
    chip.addEventListener('click', function () {
      stopRotation();
      selectMoment(i);
    });
  });

  budgets.forEach(function (chip) {
    chip.addEventListener('click', function () {
      stopRotation();
      const wasOn = chip.getAttribute('aria-pressed') === 'true';
      budgets.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', String(!wasOn));
      if (budgetLabel) {
        budgetLabel.textContent = wasOn ? budgetLabel.dataset.default : chip.textContent.trim();
      }
      updateCta();
    });
  });

  if (budgetToggle && budgetRow) {
    budgetToggle.addEventListener('click', function () {
      const open = budgetToggle.getAttribute('aria-expanded') === 'true';
      budgetToggle.setAttribute('aria-expanded', String(!open));
      budgetRow.classList.toggle('hidden', open);
      budgetRow.classList.toggle('flex', !open);
    });
  }

  root.querySelector('[data-hero-card]')?.addEventListener('pointerdown', stopRotation);

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && moments.length > 1 && reasonEl) {
    timer = setInterval(function () {
      selectMoment((index + 1) % moments.length, { fade: true, scroll: true });
    }, 2600);
  }
  updateCta();
}

// Scrollable rows (data-scroll-fade): fade the edge that has more content, so it is
// clear the row can be swiped. The fade on a side disappears once you reach that end.
function initScrollFade() {
  document.querySelectorAll('[data-scroll-fade]').forEach(function (row) {
    function update() {
      const max = row.scrollWidth - row.clientWidth;
      row.toggleAttribute('data-fade-start', max > 2 && row.scrollLeft > 4);
      row.toggleAttribute('data-fade-end', max > 2 && row.scrollLeft < max - 4);
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
    update();
  });
}
